import * as React from 'react';

import { getCookie, getQueryString, Utils, formatDate } from '@/utils/app';

import TafNetwork from '@huyafed/taf-network';
import { GameRelease } from '@/taf/jce/GameReleaseBase';
import { HUYA } from '@/taf/jce/GameMoment';
import { Toast } from 'antd-mobile';
// 文档：https://git.huya.com/huyafed/components/huyafed-npm/-/tree/master/packages/taf-network
import Spinner from './components/spinner';
import VideoBox from './components/videoBox';
import GameInfo from './components/gameInfo';
import GameDescInfo from './components/gameDescInfo';
import GameWelfare from './components/gameWelfare';
import GameReview from './components/gameReview';
import LiveGame from './components/liveGame';
import GameIntroduction from './components/gameIntroduction';
import TitleBox from './components/titleBox';
import TipsPicture from './components/tipsPicture';
import GameCoupon from './components/gameCoupon';

const { useEffect, useReducer } = React;
const { handleExposureRep, handleClickDescRep } = Utils;
const fromId = getQueryString('fromId') || getQueryString('fromid') || getQueryString('fromID') || 'app-gc';
const isDebugMode = process.env.NODE_ENV !== 'production';

const sdk = new TafNetwork({
  showLog: isDebugMode,
  isDebug: isDebugMode,
  isApp: false,
});

const userId = new GameRelease.UserId();
userId.sCookie = document.cookie;
// eslint-disable-next-line eqeqeq
userId.sHuYaUA = 'webh5&1.0.0&gamerelease';
userId.lUid = getCookie('yyuid') ? Number(getCookie('yyuid')) : 1;

function App() {
  const initState = {
    gameBaseInfo: {},
    gameResourceInfo: {},
    gameWelfareInfoList: [],
    innerWelfares: [],
    showOrder: [],
    sourceId: 0,
    loading: false,
    dataVis: false,
    liveData: [],
    introductionData: [],
    commentData: [],
    iHasMore: 0,
    iTotal: 0,
    imgVis: false,
    couponData: [],
  };
  const [state, dispatch] = useReducer((state: any, active: any) => ({ ...state, ...active }), initState);
  const { gameBaseInfo, gameResourceInfo, gameWelfareInfoList, innerWelfares, liveData, introductionData, commentData, loading, imgVis, dataVis, iHasMore, iTotal, couponData } = state;

  // 评论数据
  const getReviewData = (gameId: string) => {
    // getSimpleComment
    const req = new GameRelease.GetSimpleCommentWhitTopReq();
    req.tId = userId;
    req.iAppId = 12;
    req.sTopicId = gameId;
    req.iIndex = 0;
    req.iSize = 3;
    req.iListType = 1;
    req.topId = 0;
    sdk
      .sendWup('getSimpleComment', req, GameRelease.GetSimpleCommentWhitTopReq, GameRelease.GetSimpleCommentRsp, 'webGameCenterui')
      .then((rsp: any) => {
        // console.log('getSimpleComment --> 请求数据-req', req);
        // console.log('getSimpleComment --> 请求数据-rsp', rsp);
        dispatch({ commentData: rsp.data.vComment.value, iTotal: rsp.data.iTotal, iHasMore: rsp.data.iHasMore });
      })
      .catch((err: Error) => {
        console.log('getSimpleComment :>> err', err);
        Toast.show({ content: '评论数据找不到了！' });
      });
  };

  // 获取直播数据
  const getLiveData = (categoryId: any) => {
    const req = new GameRelease.GetGidLiveRoomReq();
    req.tId = userId;
    req.gid = categoryId;
    req.page = 1;
    req.size = 5;
    sdk
      .sendWup('getGidLiveRoom', req, GameRelease.GetGidLiveRoomReq, GameRelease.GetGidLiveRoomRsp, 'webGameCenterui')
      .then((rsp: any) => {
        // console.log('getGidLiveRoom --> 请求数据-req', req);
        // console.log('getGidLiveRoom --> 请求数据-rsp', rsp);
        if (rsp.data.response.res == 0 || rsp.data.response.msg == 'success') {
          const arrData = (rsp.data.liveRoomList.value || []).slice(0, 4).map((item: any) => ({
            ...item,
            anchorTag: item.anchorTag.value,
          }));
          dispatch({ liveData: arrData });
        } else {
          Toast.show({ content: rsp.data.response.msg || '数据找不到了！' });
        }
      })
      .catch((err: Error) => {
        console.log('getGidLiveRoom :>> err', err);
        Toast.show({ content: '直播数据找不到了！' });
      });
  };

  // 获取攻略数据
  const getGameIntroductionData = (listId: number) => {
    const req = new HUYA.GetGroupListByIdReq();
    req.tId = userId;
    req.iListId = listId;
    req.iPage = 0;
    req.iFreeFlowFlag = 0;
    sdk
      .sendWup('getGroupListById', req, HUYA.GetGroupListByIdReq, HUYA.GetGroupListByIdRsp, 'moment')
      .then((rsp: any) => {
        // console.log('getGroupListById --> 请求数据-req', req);
        // console.log('getGroupListById --> 请求数据-rsp', rsp);
        const list = (rsp.data.vGroupListItem.value || []).slice(0, 3).map((item: any) => ({
          ...item.tMoment.tMoment,
        }));
        dispatch({ introductionData: list });
      })
      .catch((err: Error) => {
        console.log('object :>> err', err);
        Toast.show({ content: '攻略数据找不到了！' });
      });
  };

  const getTime = (objDat:any) => {
    // eslint-disable-next-line prefer-const
    let strTime = '';
    const { useLifespane, effectiveEndTime, useStatus } = objDat;
    if (!useLifespane) {
      strTime += `有效期至: ${formatDate(effectiveEndTime, 'yyyy-MM-dd')}`;
    } else {
      if (useStatus === 3) {
        strTime += `领取后${useLifespane}天内有效`;
      } else if (useStatus !== 5) {
        strTime += `${formatDate(effectiveEndTime, 'yyyy-MM-dd')}前有效`;
      }
    }
    return strTime;
  };

  // 获取优惠券数据
  const getCouponData = (gameId: number) => {
    const req = new GameRelease.GetGameCouponInfoReq();
    req.tId = userId;
    req.gameId = gameId;
    req.from = 'detail';
    req.couponUUIDs.value = [];
    sdk
      .sendWup('getGameCouponInfo', req, GameRelease.GetGameCouponInfoReq, GameRelease.GetGameCouponInfoRsp, 'webGameCenterui')
      .then((rsp: any) => {
        // console.log('getGameCouponInfo --> 请求数据-req', req);
        // console.log('getGameCouponInfo --> 请求数据-rsp', rsp);
        const newData = (rsp.data.coupons.value || [])
          .reduce((cur: any, item: any) => {
            // console.log('object :>> getGameCouponInfo', item);
            cur.push({
              couponUuid: item.couponUuid,
              price: item.couponFavour / 100,
              range: item.couponMinPrice / 100,
              type: item.couponType,
              title: item.couponName,
              term: getTime(item),
              explain: item.couponDesc,
              status: item.useStatus,
              gameId: item.gameId,
              gameName: item.gameName,
              couponUsePreCondition: item.couponUsePreCondition,
            });
            return cur;
          }, [])
          // eslint-disable-next-line newline-per-chained-call
          .filter((jk: any) => jk.useStatus != 5).slice(0, 3);
        dispatch({ couponData: newData || [] });
      })
      .catch((err: Error) => {
        console.log(err);
      });
  };

  // 获取游戏详情数据
  const getGameIntroduction = (gameId: number, chId: number) => {
    // GameRelease
    const req = new GameRelease.GameDetailReq();
    req.tId = userId;
    req.gameId = gameId;
    req.chId = chId;
    dispatch({ loading: true });
    sdk
      .sendWup('getGameDetail', req, GameRelease.GameDetailReq, GameRelease.GameDetailResp, 'webGameCenterui')
      .then((rsp: any) => {
        // console.log('getGameDetail --> 请求数据-req', req);
        // console.log('getGameDetail --> 请求数据-rsp', rsp);
        if (rsp.data.response.res == 0 || rsp.data.response.msg == 'success') {
          const { categoryId, circleTabId, gameBaseInfo, gameResourceInfo, gameWelfareInfoList, innerWelfares } = rsp.data.gameDetail || {};
          dispatch({
            gameBaseInfo,
            gameResourceInfo,
            gameWelfareInfoList: gameWelfareInfoList.value,
            innerWelfares: innerWelfares.value,
            dataVis: true,
          });
          if (gameBaseInfo?.gameId) {
            getReviewData(gameBaseInfo?.gameId);
            getCouponData(gameBaseInfo?.gameId);
          }
          if (circleTabId) {
            getGameIntroductionData(circleTabId);
          }
          if (categoryId) {
            getLiveData(categoryId);
          }
          // 上报 曝光埋点
          handleExposureRep({
            gameid: gameBaseInfo?.gameId,
            gamename: gameBaseInfo?.gameName,
          });
          if(gameBaseInfo?.gameName) {
            document.title = `${gameBaseInfo.gameName}-虎牙游戏`
          }
        } else {
          Toast.show({
            content: rsp.data.response.msg || '数据找不到了！',
          });
          dispatch({ dataVis: false });
        }
        dispatch({ loading: false });
      })
      .catch((err: Error) => {
        console.log(err);
        dispatch({ loading: false });
      });
  };

  const handTipsImgVis = (value: any) => {
    if (value) {
      dispatch({ imgVis: true });
    } else {
      dispatch({ imgVis: false });
    }
  };

  const welfareTitleBoxProps = {
    title: '福利',
    more: null,
    jumpMore: () => void 0,
    handTipsImgVis,
  };

  const commentDataObj = {
    commentData,
    iTotal,
    iHasMore,
    gameBaseInfo,
    fromId,
    handTipsImgVis,
  };

  useEffect(() => {
    const id = getQueryString('gameId', '');
    const gameId = (id && Number(id));
    // 数据获取前置校验
    if (!gameId) {
      Toast.show({ content: '游戏id未配置！' });
      dispatch({ dataVis: false });
      return;
    }
    getGameIntroduction(gameId, 0);
  }, []);

  return (
    <>
      {!loading && dataVis ? (
        <div
          onClick={() =>
            handleClickDescRep({
              gamename: gameBaseInfo?.gameName,
              gameid: gameBaseInfo?.gameId,
            })
          } style={{width: '100%'}}>
          <VideoBox gameBaseInfo={gameBaseInfo} />
          <GameInfo gameBaseInfo={gameBaseInfo} gameResourceInfo={gameResourceInfo} fromId={fromId} handTipsImgVis={handTipsImgVis} />
          <div className='non-video-w'>
            <GameDescInfo gameBaseInfo={gameBaseInfo} gameResourceInfo={gameResourceInfo} handTipsImgVis={handTipsImgVis} />
            {!!(gameWelfareInfoList || []).length || !!(innerWelfares || []).length || !!(couponData || []).length ? <TitleBox {...welfareTitleBoxProps} /> : null}
            {!!(couponData || []).length ? <GameCoupon couponData={couponData} gameBaseInfo={gameBaseInfo} fromId={fromId} handTipsImgVis={handTipsImgVis} /> : null}
            {!!(gameWelfareInfoList || []).length ? (
              <GameWelfare prizeData={gameWelfareInfoList} innerTrue={false} gameBaseInfo={gameBaseInfo} fromId={fromId} handTipsImgVis={handTipsImgVis} />
            ) : null}
            {!!(innerWelfares || []).length ? <GameWelfare prizeData={innerWelfares} innerTrue={true} gameBaseInfo={gameBaseInfo} fromId={fromId} handTipsImgVis={handTipsImgVis} /> : null}
            <GameReview {...commentDataObj} />
            <LiveGame liveData={liveData} gameBaseInfo={gameBaseInfo} fromId={fromId} handTipsImgVis={handTipsImgVis} />
            <GameIntroduction introductionData={introductionData} gameBaseInfo={gameBaseInfo} fromId={fromId} handTipsImgVis={handTipsImgVis} />
          </div>
          <TipsPicture visible={imgVis} onClose={handTipsImgVis} />
        </div>
      ) : (
        <Spinner loading={loading} dataVis={dataVis} />
      )}
    </>
  );
}

export default () => <App />;
